import { AVAILABLE_APPOINTMENT_TIME_URL } from "../../constants/urls";
import { apiSlice } from "./apiSlice";

export const availableAppointmentTimeApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getAvailableAppointmentTimes: builder.mutation({
            query: () => ({
                url: `${AVAILABLE_APPOINTMENT_TIME_URL}`,
                method: 'GET'
            })
        }),
        getAvailableAppointmentTimeById: builder.mutation({
            query: (id) => ({
                url: `${AVAILABLE_APPOINTMENT_TIME_URL}/${id}`,
                method: 'GET'
            })
        }),
        updateAvailableAppointmentTimes: builder.mutation({
            query: (data) => ({
                url: `${AVAILABLE_APPOINTMENT_TIME_URL}`,
                method: 'PUT',
                body: data
            })
        }),
        generateAvailableTimes: builder.mutation({
            query: (data) => ({
                url: `${AVAILABLE_APPOINTMENT_TIME_URL}/calculateAvailableTimes`,
                method: 'POST',
                body: data
            })
        }),
        generateMultipleAvailableTimes: builder.mutation({
            query: (data) => ({
                url: `${AVAILABLE_APPOINTMENT_TIME_URL}/CalculateMultipleAvailableTimes`,
                method: 'POST',
                body: data
            })
        }),
        deleteAvailableAppointmentTime: builder.mutation({
            query: (id) => ({
                url: `${AVAILABLE_APPOINTMENT_TIME_URL}/${id}`,
                method: 'DELETE'
            })
        }),
        permanentDeleteAvailableAppointmentTime: builder.mutation({
            query: (id) => ({
                url: `${AVAILABLE_APPOINTMENT_TIME_URL}/permanent/${id}`,
                method: 'DELETE'
            })
        })
    })
});

export const {
    useGetAvailableAppointmentTimeByIdMutation,
    useGetAvailableAppointmentTimesMutation,
    useUpdateAvailableAppointmentTimesMutation,
    useGenerateAvailableTimesMutation,
    useGenerateMultipleAvailableTimesMutation,
    useDeleteAvailableAppointmentTimeMutation,
    usePermanentDeleteAvailableAppointmentTimeMutation
} = availableAppointmentTimeApiSlice;